<script setup lang="ts">
import Toast from 'primevue/toast';
import LoadingIndicator from './components/layouts/LoadingIndicator.vue';
</script>

<template>
  <LoadingIndicator/>
  <Toast position="bottom-right"/>
  <router-view></router-view>
</template>
